import { z } from 'zod';

import { VALIDATION_MESSAGES } from '@/constants/constant';

export const forgotPasswordSchema = z.object({
  email: z
    .string()
    .trim()
    .nonempty(VALIDATION_MESSAGES.email.required)
    .min(5, VALIDATION_MESSAGES.email.min)
    .max(100, VALIDATION_MESSAGES.email.max)
    .refine(
      (val) =>
        /^[a-zA-Z0-9](?!.*[-_.]{2})[a-zA-Z0-9._%+-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/.test(
          val
        ),
      { message: VALIDATION_MESSAGES.email.invalid }
    ),
});

export type TForgotPassword = z.infer<typeof forgotPasswordSchema>;
